import { FormHelperText } from '@mui/material';
import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import IPipelineObject from '../../types/IPipelineObject';

import RecruiterActivity from './RecruiterActivity';

interface IRecruiterActivity {
  name: string;
  candidateInteractionMessagingPipeline: IPipelineObject;
  selectedActions?: string[];
  candidateInteractionResultPipeline: IPipelineObject;
  selectedResults?: string[];
}

const ControlledRecruiterActivity: FC<IRecruiterActivity> = ({
  name,
  candidateInteractionMessagingPipeline,
  candidateInteractionResultPipeline,
  selectedActions,
  selectedResults,
}) => {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange }, fieldState: { error } }) => (
        <>
          <RecruiterActivity
            selectedActions={selectedActions}
            selectedResults={selectedResults}
            candidateInteractionMessagingPipeline={candidateInteractionMessagingPipeline}
            candidateInteractionResultPipeline={candidateInteractionResultPipeline}
            onInputChange={onChange}
          />
          {error && <FormHelperText error>{error.message}</FormHelperText>}
        </>
      )}
    />
  );
};

export default ControlledRecruiterActivity;
